import { render, staticRenderFns } from "./file-list.vue?vue&type=template&id=5904be77&scoped=true&"
import script from "./file-list.vue?vue&type=script&lang=js&"
export * from "./file-list.vue?vue&type=script&lang=js&"
import style0 from "./file-list.vue?vue&type=style&index=0&id=5904be77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5904be77",
  null
  
)

export default component.exports